{
	"title": "Factures",
	"buttonShowMoreInvoicesTitle": "Afficher plus de factures",
	"invoicesTableHeaders": {
		"date": "Date",
		"invoiceNumber": "Numéro de facture",
		"deliveredQuantity": "Quantité livrée",
		"bundledCarbonSavings": "Réductions de carbone groupées",
		"transactionId": "ID de transaction"
	},
	"errorMessage": "Échec du chargement des factures"
}
